// @flow

import type {ApplicationState} from '../../types'
import {createSelector} from 'reselect'

import {getDistricts} from './getDistricts'

export function getDistrictMap(appState: ApplicationState): Map<District>{
  return _getDistrictMap(appState.map) 
}

const _getDistrictMap = createSelector(
  [getDistricts.internal],
  (districts: District[]) => {
    return districts.reduce((result, d) => {
      return {
        ...result,
        [d._links.self]: d,
      }
    }, {})
  }
)

getDistrictMap.internal = _getDistrictMap
